import { render, staticRenderFns } from "./VBreadcrumb.vue?vue&type=template&id=32b24175&"
import script from "./VBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./VBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./VBreadcrumb.vue?vue&type=style&index=0&id=32b24175&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports